/**
 * Porcentaje de `value` sobre las paradas programadas, redondeado al entero.
 *
 * - `value` ausente (`null` / `undefined`): `null`. El BFF entrega los campos
 *   nuevos como opcionales y "ausente" significa "dato no disponible", que no
 *   es lo mismo que 0%.
 * - Sin paradas programadas: 0, para no producir `NaN` ni `Infinity`.
 */
export function percentOfScheduled(
  value: number | null | undefined,
  scheduledStops: number
): number | null {
  if (value == null) {
    return null;
  }

  if (scheduledStops <= 0) {
    return 0;
  }

  return Math.round((value / scheduledStops) * 100);
}
